import { useQuery } from '@tanstack/vue-query'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import type { ClidAccountOverridePayload } from '@/modules/adv/clid-account-override'
import { usePersisterFn } from '@/query/persister-plugin'
import { Persisters } from '@/query/shared'
import { useAppStore } from '@/store/app-store'
import { useAPI } from '@/utils/requests/api-plugin'

export function useClidAccountOverride() {
    const { clid, isPartnerEmbed } = storeToRefs(useAppStore())
    const api = useAPI()
    const persister = usePersisterFn(Persisters.HighCardinality)

    const queryKey = computed(() => ['clid-account-override', clid.value, isPartnerEmbed.value])

    const { data, refetch } = useQuery({
        queryKey,
        enabled: false,
        queryFn: (): Promise<ClidAccountOverridePayload | null> =>
            isPartnerEmbed.value ? api.getClidAccountOverride(clid.value) : Promise.resolve(null),
        persister,
    })

    return {
        clidAccountOverride: computed(() => data.value || null),
        fetchClidAccountOverride: () => refetch().catch(() => undefined),
    }
}
